module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "group"
  }, [_c('div', {
    staticClass: "divh"
  }, [_c('h2', {
    staticClass: "h2c"
  }, [_c('a', {
    attrs: {
      "id": "intro"
    }
  }), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_vm._v("Introduction")])]), _c('a', {
    attrs: {
      "id": "page_12"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0012-01.jpg",
      "width": "500px"
    }
  })])])]), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "big"
  }, [_c('strong', [_vm._v("Before the Blackbirds")])]), _vm._v(" were even thought about, there was the U-2, a reconnaissance aircraft built specifically to gather intelligence on foreign countries. The chief architect and designer of the U-2 was Clarence L. “Kelly” Johnson, head of Lockheed’s Advance Development Projects, better known as the Skunk Works. On 4 August 1955 the first U-2 took to the skies. Kelly knew that someday it would become vulnerable to enemy defenses, and, as early as 1958, he began to conceptualize a reconnaissance aircraft that would fly higher and over three times faster than the U-2.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lockheed received approval on 28 August 1959 to proceed with the development of five A-12 aircraft, under the Central Intelligence Agency (CIA) code name Oxcart. On 26 April 1962, just twenty-two months after Kelly started building the first A-12 Blackbird, he had the plane flying with test pilot Lou Schalk at the controls. Lockheed produced a total of fifteen A-12 aircraft for the Oxcart program. The CIA pilots flew twenty-nine operational missions out of Okinawa, Japan, from 31 May 1967 to 6 May 1968, and the planes were then retired.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_vm._v("Two of the A-12 aircraft were converted to a two-seat configuration to carry the D-21 drone and were redesignated as the M-21. The drone was launched off the back of the M-21 at Mach 3 speeds, designed to penetrate deep into enemy territory and flew a ")]), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_vm._v("preprogrammed course gathering intelligence from high altitude. At the completion of its mission, it would fly into international airspace and eject an intelligence package attached to a parachute, which was then snagged in mid-air by an Air Force cargo plane. The drone then self-destructed. Due to mixed success in obtaining good intelligence, the drone program was short-lived, and it was cancelled on 15 July 1971.")])]), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Another Blackbird variant, the YF-12, was designed to be a high-altitude, high-speed interceptor. They proved the technology and capability, but were soon canceled. Of the three built, two were lost in crashes. The remaining YF-12 is on display at the National Museum of the USAF in Dayton, Ohio.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The best known of the Blackbird family was the SR-71. Lockheed built twenty-nine SR-71A models, two SR-71B models, and one SR-71C model. The B and C models were trainer aircraft, designed and modified to teach aspiring SR-71 pilots. The first SR-71 flight took place on 22 December 1964, flown by Lockheed test pilot Bob Gilliland. Over the years, a total of eleven SR-71A models and 1 SR-71B were lost due to crashes. All remaining Blackbirds are on display at various aviation museums around the United States, with one on display in England.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Aviation fans often wonder what it was like to fly the SR-71 on secret Mach 3+ reconnaissance missions around the globe. My goal is to take you on a complete operational reconnaissance mission not only in words, but with pictures as well. The process of gathering worldwide intelligence on foreign countries with the SR-71 was both an art and science, refined over many years through searing Mach 3+ flight operations. The reader will have a better understanding of just how detailed and complex every SR-71 operational sortie was . . . from start to finish.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Air Force’s SR-71s flew 3,551 operational reconnaissance sorties from 9 March 1968 to 25 September 1989. Obviously, over twenty-two years of operational flying with the Blackbirds, many procedures changed and evolved with time, generally for the best. Don’t be surprised if you talk to a former SR-71 crew member someday and he tells you, “That’s not the way we did it when I was flying the plane.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("My time associated with the SR-71 program spans 1974–1989, as a crew member, squadron commander, vice wing commander, and wing commander. Between 1982–1986 I worked in the Pentagon, and although not directly associated with the SR-71 program, I became very aware of the politics attempting to close down the Blackbird program. I remained close to all the former SR-71 crew members working in the Pentagon, who were attempting to keep the program viable during its latter years.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a5dde904","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/intro.vue
// module id = 69
// module chunks = 0